module.exports = __webpack_public_path__ + "img/30-1-bg.ecc553d0.png";